import {
  Button,
  CircularProgress,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import ScanSelection from './scanSelection/ScanSelection'
import React from 'react'
import { RoleHierarchy } from '../../../../shared/src/data/roleHierarchy/roleHierarchy'
import { useGetScansForHierarchy } from './queries/scanMetadata'
import { ScanDetails } from '../../../../shared/src/data/scanDetails'
import { Alert, AlertTitle } from '@material-ui/lab'

type SelectScanToRunProps = {
  selectedRoleHierarchy?: RoleHierarchy
  selectedScan?: ScanDetails
  setSelectedScan: (scan?: ScanDetails) => void
  pending?: boolean
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alertContainer: {
      width: '100%',
    },
    loading: {
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  }),
)

export default function SelectScanFromHierarchy({
  selectedRoleHierarchy,
  selectedScan,
  setSelectedScan,
  pending,
}: SelectScanToRunProps): JSX.Element {
  const { data, isLoading, error, refetch } = useGetScansForHierarchy(
    selectedRoleHierarchy,
    pending,
  )

  const classes = useStyles()
  return !selectedRoleHierarchy ? (
    <></>
  ) : error ? (
    <Alert
      severity='error'
      className={classes.alertContainer}
      action={
        <Button variant='contained' color='secondary' onClick={() => refetch()}>
          RETRY
        </Button>
      }
    >
      <AlertTitle>
        <Typography variant='h6'>Failed to get scans for hierarchy</Typography>
      </AlertTitle>
      <Typography variant='subtitle1'>
        Unable to get for hierarchy: "
        {(error as Error) ? (error as Error).message : 'Unknown error'}"
      </Typography>
    </Alert>
  ) : isLoading ? (
    <CircularProgress className={classes.loading} color='secondary' />
  ) : data?.length ? (
    <ScanSelection
      scans={data}
      selectedScan={selectedScan}
      setSelectedScan={setSelectedScan}
    ></ScanSelection>
  ) : (
    <Typography variant='h6'>Branch has no pending or failed scans</Typography>
  )
}
